import React, { useState} from 'react'
import Pending from '../components/Pending'
import Message from '../components/Message'
import Button from '../components/Button'
import CreatePagination from '../components/CreatePagination'
import TableHead from '../components/TableHead'
import TableBodyRow from '../components/TableBodyRow'

function Batteries({data, error}) {
  
  const [chunk, setChunk] = useState(0)
  const [selected, setSelected] = useState(0)
  /* const [selectLocation, setSelectLocation] = useState('#')
  const [selectConStatus, setSelectConStatus] = useState('#') */
  const [sortColumn, setSortColumn] = useState('')
  const [sortOrder , setSortOrder] = useState('true')

  const [state , setState] = useState({
    location: '#',
    connstatus: '#'
  })
  
  //get all location and replace null value with 'N/A'
  const allLocations = data && data.map(lo => lo.location).map(lo => lo === null ? 'N/A' : lo)
  //get unique locations sets 
  const locationSet = new Set(allLocations && allLocations)

  //create array of array with key value pair for location Select tag header/names. Section componenent expects so. 
  const locationSelect = Array.from(locationSet).map(loc => [loc, loc])

  //handle location, connectionStatus column  select option
  const handleChange = (e) => {
    setSelected(0)
    setChunk(0)
    /* setSelectLocation(e.target.value)
    setSelectConStatus(e.target.value) */
    setState({...state,[e.target.name] :  e.target.value === 'N/A' ? null : e.target.value}) 
  }
  //handle Sort 
  const handleSort = (event) => {
    
    setSortColumn(event)
    setSortOrder(sortOrder ? false : true)
 }
//handle pagination 
  const handlePagination = (e) =>  {
    setChunk((e - 1) * 10 )
    setSelected(e * 1 - 1)
  }

  

  //filter data by location , connectionStatus
  //sort by the given voltage, capacity, connection status, etc 

  const modefiedData = data && data
          .filter(ba => state.location === '#' ? ba :  ba.location === state.location)
          .filter(b => state.connstatus === '#' ? b : b.connectionStatus  === state.connstatus * 1)
          .sort(function(a, b){
            if(sortColumn === 'lastConnectionTime'){

              return sortOrder ? 
                new Date(a[sortColumn]) - new Date (b[sortColumn])  : 
                new Date(b[sortColumn]) - new Date(a[sortColumn])

            }else if(sortColumn === 'id'){

              if(sortOrder){
                if(a[sortColumn] > b[sortColumn]) return 1
                if(a[sortColumn] < b[sortColumn]) return -1
                return 0 
              }else{
                if(a[sortColumn] > b[sortColumn]) return -1
                if(a[sortColumn] < b[sortColumn]) return 1
                return 0 
              } 
            }
            else if(sortColumn === 'recentIssues'){

              return sortOrder ? 
                a[sortColumn].length - b[sortColumn].length : 
                b[sortColumn].length - a[sortColumn].length
            }
            else{
              return sortOrder ? 
                a[sortColumn] - b[sortColumn] : 
                b[sortColumn] - a[sortColumn]
            }
          })       
  return (
    <>
      <h2>Batteries</h2>
      {/* Show message about filteration result  */}
      {
        state.location !== '#' || state.connstatus !== '#' ? 
          <div className='App-batteries-message'>
            {`There are ${modefiedData && modefiedData.length} items that met the search criteria`}
          </div> : 
          ''
      }
      {/* show Reset button on one of the ff conditions */}
      
      {
         state.location !== '#' || state.connstatus !== '#' || sortColumn ?
         <Button 
                name='Reset' 
                className={'resetfilter'}
                handleClick={function(e){
                  setSortColumn('')
                  setState({
                    connstatus: '#',
                    location: '#',
                  })
      
                }}
          />
          :
          ''
        }
     
      {!data && !error && <Pending  />} {error && <Message message={error}/>}

       <table className='App-table'>
        
          <TableHead 
            handleSort={handleSort}
            sortOrder={sortOrder}
            sortColumn={sortColumn}
            arr={locationSelect}
            select={state.location}
            selectConnStatus={state.connstatus}
            label={'location'}
            handleChange={handleChange}
          />
          
          <tbody>
          {
               //slice the data in to 10 chunks each and render 
            modefiedData && modefiedData.slice(chunk,chunk + 10).map(function(n, index) {
              return (
                 <TableBodyRow battery={n} chunk={chunk} key={index} index={index}/>
              )
            })
          }
          </tbody>
       </table>

       {/* {paginate} */}
        <>
          <CreatePagination 
            data={modefiedData} 
            selected={selected}
            handlePagination={handlePagination}
          />
        </>
    </>
  )
}

export default Batteries